/**
 * @file 接口定义文件
 * @author 李小龙
 * @date 2018/5/31
 */

const apis = {
  login: '/web/login',
  loginToken: '/web/loginByToken',
  页面按钮权限: '/button/getButtonByUserRoleRes',
  刷新项目树: '/web/selectUpdateProjects',

  //新机构申请
  getApplyType: '/apply/getApplyType', //获取申请类型(机构申请或项目申请)
  getDoUser: '/apply/getDoUser', //提交申请时获取经办人
  applyOrg: '/apply/applyOrg',
  applyOrgUpdate: '/apply/applyOrgUpdate',
  getApplyDetail: '/apply/getApplyDetail',

  //工作管理
  待办工作Select: '/apply/getApplyList',
  已办理工作Select: '/apply/getApplyList',
  getApplyDetail2: '/apply/getApplyDetail2',
  queryActPrcs: '/act/queryActPrcs', //获取流程步骤
  actCommit: '/act/commit',
  actBack: '/act/back',
  actOver: '/act/over',
  actReject: '/act/reject',
  审批日志sSelect: '/operateLog/queryActLogByPage',

  //基础数据类型
  basetypeSelect: '/baseType/select',
  baseSelByCode: '/baseType/selectByCode',

  //试药管理
  识别记录Select: '/recognition/queryByPage',
  识别记录Export: '/recognition/export',
  入组筛选Select: '/enterProject/queryExperimentByPage',
  入组筛选Export: '/enterProject/exportExperiment',
  入组筛选Info: '/enterProject/queryExperimentDetail',
  筛选失败Select: '/enterProject/queryExperimentByPage',
  筛选失败Export: '/enterProject/exportExperiment',
  筛选失败Info: '/enterProject/queryExperimentDetail',
  入组筛选移除受试者remove: '/enterProject/removeNotJoin',
  入组筛选AgreeUrl: '/enterProject/updateAgreeUrl',
  入组筛选Update: '/enterProject/update',
  志愿者Select: '/experiment/queryExperimentByPage',
  志愿者Export: '/experiment/exportExperiment',
  志愿者Finish: '/experiment/finishExperiment',
  志愿者信息Update: '/experiment/updateVolunteer',
  胸牌create: '/barcode/createIDBarCode', //创建胸牌
  胸牌prints: '/barcode/printIDSign', //打印胸牌
  条码create: '/barcode/createTubeBarCode', //生成条码
  条码prints: '/barcode/printBarCode', //批量打印条码
  志愿者testtubeSelect: '/barcode/queryByExpId', //查询志愿者试管信息
  志愿者详细Select: '/experiment/queryExperimentFlow',
  志愿者详细Insert: '/experiment/insertPersionFlow',
  志愿者详细Update: '/experiment/updatePersonFlow',
  用药记录: '/medication/queryByPage',
  志愿者详细事件记录: '/inquire/selectEvents',
  志愿者详细事件导出: '/inquire/exportEvents',
  志愿者详细问询: '/inquire/select',
  志愿者详细评价: '/inquire/getEvaluateDetail',
  志愿者流程Select: '/experiment/queryFlowById', //受试者离心和移液流程记录
  流程记录Select: '/flowRecord/queryRecordByPage',
  流程记录Export: '/flowRecord/export',
  流程历史记录: '/flowRecord/queryHistory',
  流程历史记录详情: '/flowRecord/queryHistoryDetail',
  流程记录记录Export: '/flowRecord/exportFlowRecord',
  流程记录记录Select: '/flowRecord/queryDefaultByPage',
  流程记录记录Insert: '/flowRecord/insertDefaultFlow',
  流程记录记录PeopleList: '/flowRecord/getUnFinishList',
  流程记录记录Record: '/flowRecord/insertFlowRecord',
  流程记录未完成Select: '/flowRecord/queryUnFinishedByPage',
  流程记录已完成Select: '/flowRecord/queryFinishedByPage',
  流程记录详细Export: '/flowRecord/exportFlowRecordDetail', //抽血、给药
  流程记录详细离心移液Export: '/experiment/exportFlowDetail',
  机构常用语Select: '/dialect/queryByPage',
  试验资料Select: '/flowRecord/queryInfoStoreByPage',
  试验资料Export: '/flowRecord/exportInfoStoreProject',
  试验资料Info: '/flowRecord/queryInfoStoreDetail',
  备选志愿者Insert: '/experiment/addExperiment',
  备选志愿者Update: '/experiment/updateExperiment',
  downloadVol: '/experiment/downExperimentTemplete.do', //下载志愿者导入模板
  uploadExper: '/experiment/uploadExperiment',

  //系统管理
  角色管理Select: '/role/getAllRoleInUser',
  角色管理Insert: '/role/insert',
  角色管理Delete: '/role/delete',
  角色管理Update: '/role/update',
  getRolePrivileges: '/role/getRolePrivileges', //获取权限
  getButtonByResource: '/button/getButtonByResource', //获取权限按钮
  用户管理Select: '/user/selectAll',
  志愿者管理Select: '/user/selectAll',
  用户管理Insert: '/user/insert',
  用户管理Edit: '/user/update',
  用户管理Delete: '/user/delete',
  getRoleInUpdateUser: '/user/getRoleInUpdateUser', //获取编辑的数据
  getPersonByCondition: '/role/getPersonByCondition', //查询勾选角色下的人员
  getRoleInUser: '/user/getRoleTypeInAddUser', //添加用户下的角色类型
  getRoleType: '/user/getRoleTypeInAddRole', //添加角色里的获取角色类型
  getRoleByRoleType: '/roleType/getRoleByRoleType', //添加用户下根据角色获取角色类型
  getDepartmentByUser: '/user/getDepartmentByUser', //添加用户下根据用户获取科室
  resetPassword: '/user/resetPassword', //重置密码
  distributePrivilegeForRole: '/role/distributePrivilegeForRole', //修改角色权限
  updatePassword: '/user/updatePassword', //修改密码
  用户SelectByRoleType: '/user/selectByRoleType', //角色id查询用户

  //人员管理
  人员管理Select: '/person/queryByPage',
  人员管理Insert: '/person/insert',
  运营人员管理Export: '/person/exportOperaterPerson', //运营人员列表导出
  机构人员管理Export: '/person/exportOrganResearch', //机构人员列表导出
  运营PI研究者Export: '/person/exportOperaterPi', //运营PI，研究者列表导出
  机构PI研究者Export: '/person/exportOrganPi', //机构PI，研究者列表导出
  人员管理Update: '/person/update',
  人员管理Delete: '/person/deleteById',
  人员管理UpPerDep: '/person/updatePerDep',
  人员管理ById: '/person/queryById',
  人员管理ProById: '/person/queryProById',
  人员管理ByDepId: '/person/queryByDepId',
  人员管理valPhone: '/person/validatePhone',
  人员列表详细Project: '/person/queryProjectByPerId',
  downTemplate: '/person/downPersonTemplete.do',
  uploadExcel: '/person/uploadPerson',

  //操作日志
  操作记录Select: '/operateLog/queryLogByPage',

  //机构管理
  verifyOrgName: '/org/validateName',
  verifyUserName: '/org/validateUserName',
  organizationSelect: '/org/queryOrgByPage',
  organizationExport: '/org/exportOrg',
  addOrg: '/org/insert',
  orgUpdate: '/org/update',
  orgResetPassword: '/org/resetUserPwd',
  orgqueryById: '/org/queryById',
  createUser: '/user/insert', //生成申办方、CRO、SMO账户

  //监管层
  addRegulatory: '/regulatory/insert',
  validateNameRegulatory: '/regulatory/validateName',
  regulatySelect: '/regulatory/queryByPage',
  regulatyExport: '/regulatory/exportRegulatory',
  regulatoryUpdate: '/regulatory/update',
  regulatoryId: '/regulatory/queryById',

  //申办方列表
  sponsorQueryBySelect: '/sponsor/queryBySelect',
  sponsorSelect: '/sponsor/queryByPage',
  sponsorInsert: '/sponsor/insert',
  sponsorExport: '/sponsor/exportSponsor',
  sponsorUpdate: '/sponsor/update',
  sponsorDelete: '/sponsor/deleteById',
  validateNameSponsor: '/sponsor/validateName',

  //CRO列表
  CROQueryBySelect: '/cro/queryBySelect',
  CROSelect: '/cro/queryByPage',
  CROInsert: '/cro/insert',
  CROExport: '/cro/exportCro',
  CROUpdate: '/cro/update',
  CRODelete: '/cro/deleteById',
  validateNameCRO: '/cro/validateName',

  //SMO列表
  SMOQueryBySelect: '/smo/queryBySelect',
  SMOSelect: '/smo/queryByPage',
  SMOInsert: '/smo/insert',
  SMOExport: '/smo/exportSmo',
  SMOUpdate: '/smo/update',
  SMODelete: '/smo/deleteById',
  validateNameSMO: '/smo/validateName',


  //SMO列表子账户列表
  SMOChildSelect: '/smo/queryUserByPage',
  SMOUserUpdate: '/smo/updateUser',
  SMOUserDelete: '/smo/deleteUserById',


  //科室管理
  verifyDepName: '/dep/validateName',
  departmentSelect: '/dep/queryByPage',
  departmentInsert: '/dep/insert',
  departmentExport: '/dep/exportDepartment',
  departmentUpdate: '/dep/update',
  departmentSelectByOrgId: '/dep/queryByOrgId', //通过机构查询科室
  deleteDep: '/dep/deleteById',
  departmentQueryById: '/dep/queryById',

  //项目管理
  项目列表Select: '/project/queryProjectByPage',
  项目管理Insert: '/project/insert',
  项目管理Update: '/project/update',
  项目管理Finish: '/project/finishProject',
  成员管理Select: '/project/queryProPersonByPage',
  成员管理Delete: '/project/deleteProper',
  成员管理Update: '/project/insertOrUpdateProPer',
  项目管理Validate: '/project/validateName',
  项目管理ById: '/project/queryById',
  项目类别Select: '/baseType/select',
  项目详细Select: '/project/queryProjectDetailById',
  项目详细Export: '/project/exportProjectDetails',
  成员信息File: '/person/queryByUserId',
  // 项目授权Select: '',
  设定项目流程Select: '/project/queryProjectByPage',
  设定项目流程Export: '/project/exportSetProject',
  项目筛选期流程Select: '/projectFlow/queryProjectFlowByPage',
  项目入组后流程Select: '/projectFlow/queryProjectJoinFlowByPage',
  项目流程Insert: '/projectFlow/insertProjectFlow',
  项目流程NewInsert: '/projectFlow/insertNewProjectFlow',
  项目流程Delete: '/projectFlow/deleteById',
  项目流程Update: '/projectFlow/updateById',
  项目状态ExpNotGroupAndIn: '/project/selectExpNotGroupAndInByPro',
  项目状态Update: '/project/updateProStatus',
  项目列表Export2: '/project/exportOperaterProject', //运营平台导出
  项目列表Export4: '/project/exportOrgProject', //机构平台导出
  项目列表Export5: '/project/exportSponsorProject', //申办方导出
  //流程提醒设定
  流程提醒Delete: '/fllowupRemind/deleteById',
  流程提醒Insert: '/fllowupRemind/insert',
  流程提醒Select: '/fllowupRemind/queryAll',
  流程提醒时间Select: '/fllowupRemind/queryTimeSetting',
  流程提醒Update: '/fllowupRemind/update',
  流程提醒时间Update: '/fllowupRemind/updateProSetting',
  流程提醒Validate: '/fllowupRemind/validateName',

  //流程常用语管理
  流程常用语管理Insert: '/dialect/insert',
  流程常用语管理Select: '/dialect/queryByPage',
  流程常用语管理Update: '/dialect/update',
  流程常用语管理ById: '/dialect/queryById',
  流程常用语管理ByName: '/dialect/queryByName',
  流程常用语管理Delete: '/dialect/deleteById',
  流程常用语管理Validate: '/dialect/validateName',

  //流程以及流程步骤
  模板管理Select: '/actForm/selectAll',
  流程Insert: '/act/insert',
  流程Delete: '/act/deleteFlowById',
  流程Update: '/act/updateFlowById',
  流程启动: '/act/doFlow',
  流程禁用: '/act/undoFlow',
  流程SelectById: '/act/queryFlowById',
  流程步骤Insert: '/act/insertPrcs',
  流程步骤Delete: '/act/deletePrcs',
  流程步骤Update: '/act/updatePrcs',
  流程步骤QueryById: '/act/queryActPrcs',
  流程设计Select: '/act/queryByPage',
  流程用户Select: '/roleType/getParentRoleType',

  //菜单管理
  // 菜单管理Select: '/resource/selectAll',
  菜单管理Insert: '/resource/insert',
  菜单管理Update: '/resource/update',
  菜单管理Select: '/resource/getAllResByPlatformId', //根据平台id

  //角色类型管理
  角色类型Select: '/roleType/getRoleTypeByType',
  角色类型Insert: '/roleType/insertRoleType',
  角色类型Update: '/roleType/updateRoleType',
  角色类型Delete: '/roleType/deleteRoleType',
  getPlatform: '/platform/getPlatform', //查询平台
  getAllResources: '/roleType/getAllResources', //角色权限树
  defaultResRoleType: '/roleType/defaultResRoleType', //角色类型管理权限树保存
  // insertPlatform: '/user/insertPlatform', // 新增平台账号
  getRoleTypeByType: '/roleType/getRoleTypeByType', //获取所有角色配置
  updateRoleType: '/roleType/updateRoleType', //动态配置角色
  getRoleTypeInPlatform: '/roleType/getRoleTypeInPlatform', //获取页签

  //运营平台管理
  运营平台管理Select: '/user/selectPlatform',
  运营平台管理Insert: '/user/insertPlatform',
  运营平台管理Update: '/user/updatePlatform',
  运营平台管理Delete: '/user/deletePlatform',

  //控制台
  数据统计概况: '/home/selectTodayStatCount',
  项目进展情况: '/home/selectProjectProgressInfo',

  //app升级
  终端APP升级Select: '/UpdateFile/selectByPara',
  终端APP升级Insert: '/UpdateFile/insert',

  //新项目申请
   新项目申请Insert: '/apply/applyProject',
   新项目申请Update: '/apply/applyProjecUpdate',
   项目机构Select: '/apply/getOrgList',

   //新增筛选期流程
   筛选期流程: '/projectFlow/queryProjectFlowByPage',
   筛选期流程Save: '/enterProject/updateAgreeUrlOrFlow',

   //手机端页面获取最新下载版本
   最新版本: '/UpdateFile/selectNewVersion'
   

}
for (let i in apis) {
  apis[i] = API_DOMAIN + apis[i]
}

const uploadApis = {
  fileUpload: '/hospitalch/upload', //文件上传
  fileHtmlUp: '/hospitalch/uploadHtml',
  fileLogoUp: '/hospitalch/uploadLogo', //logo上传
  uploadFileOSS: '/hospitalch/uploadFileOSS'
}
for (let i in uploadApis) {
  uploadApis[i] = UPLOAD_DOMAIN + uploadApis[i]
}

const getoken = {
  getToken: '/getToken', //token获取
}
for (let i in getoken) {
  getoken[i] = TOKEN_DOMAIN + getoken[i]
}

const printObj = {
  条码print: '/barcode/print' //打印条码
}
for (let i in printObj) {
  printObj[i] = PRINT_DOMAIN + printObj[i]
}

export default Object.assign({}, apis, uploadApis, getoken, printObj)



// WEBPACK FOOTER //
// ./src/js/apis.js